module.exports = __webpack_public_path__ + "img/flag_basque.12004469.png";